import 'toaster-js/default.scss';
import './theme.scss';
import { createApp } from 'vue';
import Main from './main.vue';
import ElementPlus from "element-plus";
import 'element-plus/lib/theme-chalk/index.css';
// import localisation from './localisations';

const app = createApp(Main);
app.use(ElementPlus);

// app.provide('localization', localisation);

app.mount('#app');
